import { render } from "./WritingSystemChart.vue?vue&type=template&id=ef07744a&scoped=true"
import script from "./WritingSystemChart.vue?vue&type=script&lang=js"
export * from "./WritingSystemChart.vue?vue&type=script&lang=js"

import "./WritingSystemChart.vue?vue&type=style&index=0&id=ef07744a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef07744a"]])

export default __exports__